import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PlusV2IconSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none'>
    <rect width='24' height='24' transform='translate(0.9375 0.132812)' fill='white' />
    <path
      d='M12.9375 1.70312L12.9375 22.2159'
      stroke='#050530'
      stroke-width='3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M2.67969 11.9531L23.1925 11.9531'
      stroke='#050530'
      stroke-width='3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const PlusV2Icon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlusV2IconSvg} {...props} />
);
